import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort, MatSnackBarConfig, MatSnackBar, MatDialogConfig } from '@angular/material';
import { HttpClient } from '@angular/common/http';
import { ListColumn } from '../../../core/list/list-column.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ROUTE_TRANSITION } from '../../../app.animation';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/interval';
import 'rxjs/add/operator/map';

import { I18n } from '@ngx-translate/i18n-polyfill';

import { environment } from '../../../../environments/environment';
import { DataGeneric } from '../../../core/list/list-datageneric';
import { DeleteDialogComponent } from '../../../core/dialogs/deleted-dialog/delete-dialog.component';
import { NewHttpDao } from '../../../core/utils/new-http-dao';
import { AuthGuard } from '../../../core/auth/auth.guard';
import {CreateAuditDialogComponent} from '../../../core/dialogs/create-audit-dialog/create-audit-dialog.component';
import {ExportAuditDialogComponent} from '../../../core/dialogs/export-audit-dialog/export-audit-dialog.component';
import { generateSynthesePdf } from './audit-synthese-pdf';

import {CopyDialogComponent} from '../../../core/dialogs/copy-dialog/copy-dialog.component';
import { PreviewAuditDialogComponent } from '../../../core/dialogs/preview-audit-dialog/preview-audit-dialog.component';
import { PreviewAuditPictureDialogComponent } from '../../../core/dialogs/preview-audit-picture-dialog/preview-audit-picture-dialog.component';

@Component({
  selector: 'vr-audit-list',
  templateUrl: './audit-list.component.html',
  styleUrls: ['./audit-list.component.scss'],
  animations: [...ROUTE_TRANSITION],
  host: { '[@routeTransition]': '' }
})
export class AuditListComponent implements OnInit {

  pageName: string;
  scrollbar: any;
  getAuditsDatabase: DataHttpDao | null;
  dataSource: AuditsDataSource | null;

  internal = false;
  state = 'draft';
  isExporting = false;
  exportProgress: string | null = null;
  searchTerm = '';

  @Input()
  columns: ListColumn[] = [
    { name: 'N°', model: ['Audits', 'id'], property: 'Audits.id', visible: true, isModelProperty: true },
    { name: this.i18n({value: 'Effectué par', id: 'DoneBy'}), model: ['DoneBy', 'name'], property: 'DoneBy.firstname', visible: true, isModelProperty: true },
    { name: this.i18n({value: 'Auditor', id: 'Auditor'}), model: ['Auditor', 'name'], property: 'Auditor.name', visible: true, isModelProperty: true },
    { name: this.i18n({value: 'Audited', id: 'Audited'}), model: ['Audited', 'name'], property: 'Audited.name', visible: true, isModelProperty: true },
    { name: this.i18n({value: 'Frame', id: 'Frame'}), model: ['Audits', 'frame_name'], property: 'Audits.frame_name', visible: true, isModelProperty: true },
	{ name: this.i18n({value: 'Date', id: 'Date'}), model: ['Audits', 'started_at'], property: 'Audits.started_at', visible: true, isModelProperty: true }
  ] as ListColumn[];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }

  constructor(
    private router: Router,
    private http: HttpClient,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private changeDetectorRefs: ChangeDetectorRef,
    public authGuard: AuthGuard,
    private i18n: I18n,
    private activatedRoute: ActivatedRoute
  ) {
    if (this.activatedRoute.snapshot.data.action === 'auditsPerformedDraft') {
      this.pageName = this.i18n({value: 'Performed draft audits', id: 'BreadcrumbsAuditsPerformedDraft'});
      this.internal = false;
      this.state = 'draft';
    } else if (this.activatedRoute.snapshot.data.action === 'auditsPerformedWaiting') {
      this.pageName = this.i18n({value: 'Performed waiting for validation audits', id: 'BreadcrumbsAuditsPerformedWaiting'});
      this.internal = false;
      this.state = 'waiting';
    } else if (this.activatedRoute.snapshot.data.action === 'auditsPerformedValidated') {
      this.pageName = this.i18n({value: 'Performed validated audits', id: 'BreadcrumbsAuditsPerformedValidated'});
      this.internal = false;
      this.state = 'validated';
    } else if (this.activatedRoute.snapshot.data.action === 'auditsInternalDraft') {
      this.pageName = this.i18n({value: 'Internal draft audits', id: 'BreadcrumbsAuditsInternalDraft'});
      this.internal = true;
      this.state = 'draft';
    } else if (this.activatedRoute.snapshot.data.action === 'auditsInternalWaiting') {
      this.pageName = this.i18n({value: 'Internal waiting for validation audits', id: 'BreadcrumbsAuditsInternalWaiting'});
      this.internal = true;
      this.state = 'waiting';
    } else if (this.activatedRoute.snapshot.data.action === 'auditsInternalValidated') {
      this.pageName = this.i18n({value: 'Internal validated audits', id: 'BreadcrumbsAuditsInternalValidated'});
      this.internal = true;
      this.state = 'validated';
    }
    if (this.state === 'validated') {
      this.columns.push({ name: this.i18n({value: 'Note', id: 'Note'}), model: ['Audits', 'note'], property: 'Audits.note', visible: true, isModelProperty: true })
    }
    if (this.state === 'validated' || this.state === 'draft' || this.state === 'waiting') {
      this.columns.push({ name: this.i18n({value: 'Actions', id: 'Actions'}), property: 'actions', visible: true })
    }
    this.getAuditsDatabase = new DataHttpDao(this.authGuard, this.http, this.internal, this.state);
    this.searchTerm = this.activatedRoute.snapshot.queryParams['search'] || '';
  }

  /**
   * Init
   * Init data
   */
  ngOnInit() {
    this.dataSource = new AuditsDataSource(this.changeDetectorRefs, this.getAuditsDatabase!, this.columns, this.sort, this.paginator);
  }

  /**
   * filter data
   * @param value
   */
  onFilterChange(value) {
    this.dataSource.filter = value;
    this.searchTerm = value;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { search: value || null },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  typeFilter(download) {
    if (download == 'all') {

      this.state = 'validated'

    } else {

      if (download) {
        this.state = 'download';
      }
      if (!download) {
        this.state = 'notDownload';
      }
    }
    
    this.getAuditsDatabase = new DataHttpDao(this.authGuard, this.http, this.internal, this.state);
    this.dataSource = new AuditsDataSource(this.changeDetectorRefs, this.getAuditsDatabase!, this.columns, this.sort, this.paginator);
  }

  /**
   * Open modal to ask for frame
   * then create audit and redirect to edit this audit
   */
  createAudit() {
    this.dialog.open(CreateAuditDialogComponent, {} as MatDialogConfig).afterClosed().subscribe((frame_id) => {
      if (frame_id) {
        this.http.post(environment.API_PATH + 'audit', {audited_id: this.authGuard.getCurrentEnterpriseId(), frame_id: frame_id}, {withCredentials: true}).subscribe(response => {
          if (response['success']) {
            this.snackBar.open(this.i18n({value: 'Audit created with success', id: 'AuditCreatedWithSuccess'}), '', {duration: 5000} as MatSnackBarConfig);
            this.router.navigate(['/audit/edit/' + response['audit']['id']]).then();
          }
          this.changeDetectorRefs.detectChanges();
        }, err => {
          this.snackBar.open(this.i18n({value: 'An error has occurred, please try again.', id: 'ErrorDatabase'}), '', {duration: 5000} as MatSnackBarConfig);
          this.changeDetectorRefs.detectChanges();
        });
      }
    });
  }


  /**
   * Open modal to ask for frame, date start and end to extract file CSV Data
   * 
   */
    exportAudits() {
      this.dialog.open(ExportAuditDialogComponent, {} as MatDialogConfig).afterClosed().subscribe((data) => {

        this.isExporting = true;
        this.exportProgress = 'Chargement...';
        this.changeDetectorRefs.detectChanges();

        const onError = () => {
          this.snackBar.open(this.i18n({value: 'An error has occurred, please try again.', id: 'ErrorDatabase'}), '', {duration: 5000} as MatSnackBarConfig);
          this.isExporting = false;
          this.exportProgress = null;
          this.changeDetectorRefs.detectChanges();
        };

        if (data.id) {
          // Cas frame_id seul — pas paginé côté serveur, comportement inchangé
          this.http.post(environment.API_PATH + 'audit/export', {audited_id: this.authGuard.getCurrentEnterpriseId(), frame_id: data.id, start: data.start, end: data.end}, {withCredentials: true}).subscribe(response => {
            this.downloadFile(response, false);
            this.isExporting = false;
            this.exportProgress = null;
            this.changeDetectorRefs.detectChanges();
          }, onError);
        } else {
          let baseParams: any;
          let formats: any = null;
          if (data.exportAll) {
            baseParams = {start: data.start, end: data.end};
          } else if (data.exportByEnterprise) {
            baseParams = {audited_id: data.audited_id, start: data.start, end: data.end};
          } else {
            // Export détaillé : data est un tableau [{id, start, end, formats?}]
            formats = Array.isArray(data) && data[0] && data[0].formats ? data[0].formats : null;
            baseParams = Array.isArray(data)
              ? data.map(({ formats: _f, ...rest }) => rest)
              : data;
          }
          const exportStart = Array.isArray(data) && data[0] ? data[0].start : null;
          const exportEnd   = Array.isArray(data) && data[0] ? data[0].end   : null;
          this.fetchPaginatedExport(baseParams, [], onError, (allAudits) => {
            if (!formats || formats.csv !== false) {
              this.downloadFile({ audits: allAudits }, true);
            }
            if (formats && formats.pdf === true && allAudits.length > 0) {
              const frameName      = allAudits[0].frame_name    || '';
              const enterpriseName = allAudits[0].NomEntreprise || '';
              const trameId        = allAudits[0].TrameId;
              this.exportProgress = 'Récupération des données de la trame...';
              this.changeDetectorRefs.detectChanges();
              this.http.get(environment.API_PATH + 'frame/' + trameId, {withCredentials: true}).subscribe((frameResp: any) => {
                const frameColors = (frameResp && frameResp.frame && frameResp.frame.frame_resultat_colors) || [];
                this.exportProgress = 'Génération du PDF en cours...';
                this.changeDetectorRefs.detectChanges();
                setTimeout(() => {
                  generateSynthesePdf(allAudits, frameName, exportStart, exportEnd, enterpriseName, frameColors);
                  this.isExporting = false;
                  this.exportProgress = null;
                  this.changeDetectorRefs.detectChanges();
                }, 50);
              }, () => {
                this.exportProgress = 'Génération du PDF en cours...';
                this.changeDetectorRefs.detectChanges();
                setTimeout(() => {
                  generateSynthesePdf(allAudits, frameName, exportStart, exportEnd, enterpriseName, []);
                  this.isExporting = false;
                  this.exportProgress = null;
                  this.changeDetectorRefs.detectChanges();
                }, 50);
              });
            } else {
              this.isExporting = false;
              this.exportProgress = null;
              this.changeDetectorRefs.detectChanges();
            }
          });
        }
      });
    }

    private fetchPaginatedExport(baseParams: any, accumulated: any[], onError: () => void, onComplete: (audits: any[]) => void, offset = 0) {
      const LIMIT = 500;
      const params = { ...baseParams, limit: LIMIT, offset };

      this.http.post(environment.API_PATH + 'audit/export', params, {withCredentials: true}).subscribe(response => {
        const audits = response['audits'] || [];
        const total = response['total'] || 0;
        const allSoFar = accumulated.concat(audits);

        if (total === 0 || audits.length === 0) {
          onComplete(allSoFar);
          return;
        }

        const auditsLoaded = Math.min(offset + LIMIT, total);
        this.exportProgress = `${auditsLoaded} / ${total} audits chargés`;
        this.changeDetectorRefs.detectChanges();

        const nextOffset = offset + LIMIT;
        if (nextOffset < total) {
          this.fetchPaginatedExport(baseParams, allSoFar, onError, onComplete, nextOffset);
        } else {
          onComplete(allSoFar);
        }
      }, onError);
    }
  
downloadFile(data, detail = false) {
  data = data.audits;
  if(data.length == 0) {
    this.snackBar.open(this.i18n({value: 'Empty csv file.', id: 'ErrorEmptyCSV'}), '', {duration: 5000} as MatSnackBarConfig);
    return 
  }
  let arrHeader = ["id", "int_nbr_customer_id", "name", "User","started_at","ended_at","frame_name", "value_note"];

  let arrHeaderDetail = ["AuditId","TrameId", "frame_name", "User", "NomEntreprise", "internal_code", "int_nbr_customer_id", "note", "id", "NomNote", "ValeurNote", "typeNote", "started_at", "updated", "KoConforme", "IdItem", "DetailItem","EvaluationItem", "ObservationItem"];
  let csvData = detail ? this.ConvertToCSVDetail(data, arrHeaderDetail) : this.ConvertToCSV(data, arrHeader);
  let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
  let dwldLink = document.createElement("a");
  let url = URL.createObjectURL(blob);
  let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
  if (isSafariBrowser) {
    dwldLink.setAttribute("target", "_blank");
  }
  dwldLink.setAttribute("href", url);
  dwldLink.setAttribute("download", "auditExport.csv");
  dwldLink.style.visibility = "hidden";
  document.body.appendChild(dwldLink);
  dwldLink.click();
  document.body.removeChild(dwldLink);
}

ConvertToCSV(objArray, headerList) {
  let str = '';
  let row = '';
  
  let newHeaders = ["Référence de la visite","CodeSite AQCF","Nom établissement","Référence technicien", "DateAudit","Heure début audit", "Heure fin audit","Nom grille","Note audit"];

  for (let index in newHeaders) {
    row += newHeaders[index] + '|';
  }
  
  // Ajouter les colonnes notes_chapitres entre Note audit et les colonnes A1
  let chapitreHeaders = []; // Array of chapitre names
  if (objArray.length > 0 && objArray[0].notes_chapitres && objArray[0].notes_chapitres.length > 0) {
    for (let chapitre of objArray[0].notes_chapitres) {
      chapitreHeaders.push(chapitre.Chapitre);
      row += chapitre.Chapitre + '|';
    }
  }

  // Ajouter les colonnes dynamiques en fonction de l'ordre réel des items
  let headerMap = []; // Array of {groupId, itemIndex, headerName}
  let currentLetter = 'A';
  let currentNumber = 1;
  let lastGroupId = null;

  // Analyser le premier audit pour générer les headers
  if (objArray.length > 0 && objArray[0].items && objArray[0].items.length > 0) {
    for (let itemIdx = 0; itemIdx < objArray[0].items.length; itemIdx++) {
      let item = objArray[0].items[itemIdx];
      let groupId = item.group_id;
      
      // Si on change de groupe, on passe à la lettre suivante
      if (lastGroupId !== groupId && lastGroupId !== null) {
        currentLetter = String.fromCharCode(currentLetter.charCodeAt(0) + 1);
        currentNumber = 1;
      }
      
      let headerName = currentLetter + currentNumber;
      headerMap.push({groupId, itemIndex: itemIdx, headerName});
      row += headerName + '|';
      
      currentNumber++;
      lastGroupId = groupId;
    }
  }
  
  str += row + '\r\n';
  
  // Créer une map audit_id -> tous les items de cet audit
  let auditItemsMap = {};
  for (let i = 0; i < objArray.length; i++) {
    let auditId = objArray[i].id;
    if (!auditItemsMap[auditId]) {
      auditItemsMap[auditId] = objArray[i];
    }
  }
  
  for (let auditId in auditItemsMap) {
    let audit = auditItemsMap[auditId];
    let line = '';
    
    
    for (let index in headerList) {
      let head = headerList[index];
      
      // Traiter les dates
      if (head === 'started_at') {
        let dateDebut = audit[head] ? audit[head].split(' ')[0] : '';
        line += this.strRep(dateDebut) + '|' ;
        let heureDebut = audit['started_at'] ? audit['started_at'].split(' ')[1] : '';
        line += this.strRep(heureDebut) + '|';
      } else if (head === 'ended_at') {
        let heureFin = audit['ended_at'] ? audit['ended_at'].split(' ')[1] : '';
        line += this.strRep(heureFin) + '|';
      } else {
        line += this.strRep(audit[head])+ '|';
      }
    }
    
    // Ajouter les valeurs des notes_chapitres
    for (let chapitreNom of chapitreHeaders) {
      let chapitreNote = '';
      if (audit.notes_chapitres && audit.notes_chapitres.length > 0) {
        let found = audit.notes_chapitres.find((c: {Chapitre: string, Note: string}) => c.Chapitre === chapitreNom);
        if (found) {
          chapitreNote = parseFloat(found.Note) < 0 ? '0' : found.Note;
        }
      }
      line += this.strRep(chapitreNote) + '|';
    }

    // Ajouter les valeurs des items pour chaque colonne (dans l'ordre)
    for (let headerInfo of headerMap) {
      let value = '';
      if (audit.items && audit.items[headerInfo.itemIndex]) {
        value = audit.items[headerInfo.itemIndex].response_evaluation;
      }
      line += this.strRep(value) + '|';
    }
    
    str += line + '\r\n';
  }
  return str;
}

    ConvertToCSVDetail(objArray, headerList) {

      let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      let str = '';
      let row = 'S.No|';

      let newHeaders = ["AuditId","TrameId", "frame_name", "User", "NomEntreprise", "internal_code", "int_nbr_customer_id", "note points", "note globale", "id", "NomNote", "ValeurNote", "TypeNote", "started_at", "updated", "KoConforme", "IdItem", "DetailItem","EvaluationItem", "ObservationItem"];

      const typeNoteLabels = { '0': 'Global', '1': 'Indicateurs', '2': 'Chapitres' };

      // Pré-construire un map AuditId → note globale (ValeurNote où typeNote = 0)
      const globalNoteByAudit = {};
      for (let i = 0; i < array.length; i++) {
        const auditId = array[i]['AuditId'];
        if (String(array[i]['typeNote']) === '0' && globalNoteByAudit[auditId] === undefined) {
          globalNoteByAudit[auditId] = array[i]['ValeurNote'];
        }
      }

      for (let index in newHeaders) {
        row += newHeaders[index] + '|';
      }
      row = row.slice(0, -1);
      str += row + '\r\n';
      for (let i = 0; i < objArray.length; i++) {
        let line = (i + 1) + '';
        for (let index in headerList) {
          let head = headerList[index];
          if (head === 'note') {
            line += '|' + this.strRep(array[i][head]);
            line += '|' + this.strRep(globalNoteByAudit[array[i]['AuditId']]);
          } else if (head === 'typeNote') {
            const val = String(array[i][head]);
            line += '|' + this.strRep(typeNoteLabels[val] || val);
          } else {
            line += '|' + this.strRep(array[i][head]);
          }
        }
        str += line + '\r\n';
      }

      return str;
    }

    strRep(data) {
      if(typeof data == "string") {
        let newData = data.replace(/\|/g, " ").replace(/[\r\n]+/g, " ");
          return newData;
      }
      else if(typeof data == "undefined") {
        return "-";
      }
      else if(typeof data == "number") {
        return  data.toString();
      }
      else {
        return data;
      }
    }

  /**
   * redirect to update audit
   * @param id - audit id
   * @param frameName - frame name
   */
  updateAudit(id, frameName) {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    if (frameName === 'AUDIT PHOTO' && this.authGuard.hasAccess('editDraftAuditPicture')) {
      this.router.navigate(['/audit-picture/edit/' + id], { queryParams }).then(() => {});
    } else if (frameName !== 'AUDIT PHOTO' && this.authGuard.hasAccess('editDraftAudit')) {
      this.router.navigate(['/audit/edit/' + id], { queryParams }).then(() => {});
    }
  }

  /**
   * Open modal to confirm
   * Then delete audit
   * @param audit - audit
   */
  deleteAudit(audit) {
    const auditId = parseInt(audit.Audits.id, 10);
    this.http.get(environment.API_PATH + 'audit/' + auditId, {withCredentials: true}).subscribe((getResponse: any) => {
      if (getResponse && getResponse.audit) {
        const fullAudit = getResponse.audit;
        const openActions: any[] = [];
        if (fullAudit.audit_item_groups) {
          for (const group of fullAudit.audit_item_groups) {
            for (const item of (group.audit_items || [])) {
              for (const action of (item.audit_actions || [])) {
                if (action.status !== 'COMPLETED') {
                  openActions.push(action);
                }
              }
            }
          }
        }
        if (openActions.length > 0) {
          this.snackBar.open(
            `Attention : ${openActions.length} plan(s) d'action non terminé(s) sont liés à cet audit et seront également supprimés.`,
            '',
            { duration: 6000 } as MatSnackBarConfig
          );
        }
        this.dialog.open(DeleteDialogComponent, {
          data: audit
        } as MatDialogConfig).afterClosed().subscribe((id) => {
          if (id) {
            this.http.delete(environment.API_PATH + 'audit/' + id, {withCredentials: true}).subscribe(response => {
              if (response['success']) {
                this.dataSource = new AuditsDataSource(this.changeDetectorRefs, this.getAuditsDatabase!, this.columns, this.sort, this.paginator);
                this.changeDetectorRefs.detectChanges();
              } else {
                this.snackBar.open(response['errors']['general']['message'], '', { duration: 5000 } as MatSnackBarConfig);
              }
            }, err => {
              this.snackBar.open(this.i18n({value: 'An error has occurred, please try again.', id: 'ErrorDatabase'}), '', { duration: 5000 } as MatSnackBarConfig);
            });
          }
        });
      } else {
        this.snackBar.open(this.i18n({value: 'An error has occurred, please try again.', id: 'ErrorDatabase'}), '', { duration: 5000 } as MatSnackBarConfig);
      }
    }, err => {
      this.snackBar.open(this.i18n({value: 'An error has occurred, please try again.', id: 'ErrorDatabase'}), '', { duration: 5000 } as MatSnackBarConfig);
    });
  }

  /**
   * Download pdf
   * @param row
   */
  downloadPdf(row) {
    // Ouverture dans un nouvel onglet : un `document.location.href` sur l'onglet courant
    // fait perdre tout l'état de la liste (recherche, tri, pagination) si le backend ne
    // répond pas avec un Content-Disposition: attachment.
    window.open(environment.API_PATH + 'audit/pdf/' + row.Audits.id, '_blank');

    // Rafraîchit les lignes affichées (le statut "téléchargé" change côté backend après le PDF)
    // sans recréer la dataSource, pour conserver le filtre/tri/pagination en cours.
    setTimeout(() => {
      this.dataSource.filter = this.dataSource.filter;
    }, 1000);
  }

  /**
   * Download action plan excel file
   * @param row
   */
  downloadActionPlanXlsx(row) {
    window.open(environment.API_PATH + 'audit/plan-action/excel/' + row.Audits.id, '_blank');
  }

  /**
   * Reset audit to draft
   * @param row
   */
  private normalizeDates(obj: any): any {
    if (obj === null || obj === undefined) return obj;
    if (Array.isArray(obj)) return obj.map(item => this.normalizeDates(item));
    if (typeof obj === 'object') {
      const result = {};
      for (const key of Object.keys(obj)) {
        result[key] = this.normalizeDates(obj[key]);
      }
      return result;
    }
    if (typeof obj === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(obj)) {
      return obj.replace('T', ' ').replace(/(\.\d+)?(Z|[+-]\d{2}:\d{2})?$/, '');
    }
    return obj;
  }

  resetToDraft(row) {
    const auditId = parseInt(row.Audits.id, 10);
    this.http.get(environment.API_PATH + 'audit/' + auditId, {withCredentials: true}).subscribe((getResponse: any) => {
      if (getResponse && getResponse.audit) {
        const audit = this.normalizeDates(getResponse.audit);
        audit.is_draft = true;
        audit.is_validated = false;
        this.http.put(environment.API_PATH + 'audit', { audit: audit }, {withCredentials: true}).subscribe(response => {
          if (response['success']) {
            this.snackBar.open('Audit remis en brouillon.', '', {duration: 5000} as MatSnackBarConfig);
            this.getAuditsDatabase = new DataHttpDao(this.authGuard, this.http, this.internal, this.state);
            this.dataSource = new AuditsDataSource(this.changeDetectorRefs, this.getAuditsDatabase!, this.columns, this.sort, this.paginator);
          } else {
            this.snackBar.open(this.i18n({value: 'An error has occurred, please try again.', id: 'ErrorDatabase'}), '', {duration: 5000} as MatSnackBarConfig);
          }
          this.changeDetectorRefs.detectChanges();
        }, err => {
          this.snackBar.open(this.i18n({value: 'An error has occurred, please try again.', id: 'ErrorDatabase'}), '', {duration: 5000} as MatSnackBarConfig);
          this.changeDetectorRefs.detectChanges();
        });
      } else {
        this.snackBar.open(this.i18n({value: 'An error has occurred, please try again.', id: 'ErrorDatabase'}), '', {duration: 5000} as MatSnackBarConfig);
        this.changeDetectorRefs.detectChanges();
      }
    }, err => {
      this.snackBar.open(this.i18n({value: 'An error has occurred, please try again.', id: 'ErrorDatabase'}), '', {duration: 5000} as MatSnackBarConfig);
      this.changeDetectorRefs.detectChanges();
    });
  }

  /**
   * Duplicate audit
   * @param row
   */
  openPreview(row) {
    this.http.get(environment.API_PATH + 'audit/' + row.Audits.id, { withCredentials: true }).subscribe(response => {
      if (response['success']) {
        const audit = response['audit'];
        const old = response['old'] || [];
        const frameEvalOptions = response['frame_evaluation_options'] || (audit.frame && audit.frame.frame_evaluation_options) || [];
        const stats = [];

        // Le backend renvoie parfois coefficient/malus/ko/evaluation/categories/information sous forme
        // de chaîne JSON non parsée : on normalise avant tout calcul pour éviter les NaN silencieux.
        const safeParseJSON = (value: any, fallback: any): any => {
          if (value === null || value === undefined) { return fallback; }
          if (typeof value !== 'string') { return value; }
          try {
            const parsed = JSON.parse(value);
            return parsed === null || parsed === undefined ? fallback : parsed;
          } catch (e) {
            return fallback;
          }
        };
        const normalizeAudit = (a: any) => {
          if (!a) { return; }
          a.coefficient = safeParseJSON(a.coefficient, {});
          a.malus = safeParseJSON(a.malus, {});
          a.ko = safeParseJSON(a.ko, {});
          (a.audit_item_groups || []).forEach((group: any) => {
            (group.audit_items || []).forEach((item: any) => {
              item.evaluation = safeParseJSON(item.evaluation, {});
              item.categories = safeParseJSON(item.categories, []);
              item.information = safeParseJSON(item.information, []);
            });
          });
        };
        normalizeAudit(audit);
        old.forEach((oldAudit: any) => normalizeAudit(oldAudit));

        const addCategoryToStats = (category, item, elem) => {
          const coefficient = (audit.coefficient && item.item_type && audit.coefficient[item.item_type]) ? audit.coefficient[item.item_type] : 1;
          let found = stats.find(s => s.category === category);
          if (!found) {
            found = { category, values: { 0: 0, 1: 0, 2: 0, 3: 0 }, max: { 0: 0, 1: 0, 2: 0, 3: 0 } };
            stats.push(found);
          }
          let max = 0;
          for (const key in item.evaluation) {
            if (item.evaluation[key] > max) { max = item.evaluation[key]; }
          }
          found.max[elem] += coefficient * max;
          if (item.response_evaluation === 'NC') {
            const ncKey = ['NCMIN', 'NCMOD', 'NCMAJ', 'NCCRI'].find(k => item.evaluation[k] !== undefined);
            if (ncKey) { found.values[elem] += coefficient * item.evaluation[ncKey]; }
          } else if (item.response_evaluation) {
            found.values[elem] += coefficient * (item.evaluation[item.response_evaluation] || 0);
          }
          if (found.values[elem] < 0) { found.values[elem] = 0; }
        };

        audit.audit_item_groups.forEach(group => {
          group.audit_items.forEach(item => {
            if (Array.isArray(item.categories) && item.response_evaluation !== 'SO' && item.response_evaluation !== 'PO') {
              item.categories.forEach(cat => addCategoryToStats(cat, item, 0));
            }
          });
        });

        const calcGlobalNote = (a: any) => {
          let tv = 0, tm = 0, malusP = 0, nbKO = 0;
          const m = a.malus || {};
          const koOrder = ['un', 'deux', 'trois', 'quatre'];
          (a.audit_item_groups || []).forEach((g: any) => {
            (g.audit_items || []).forEach((item: any) => {
              const coeff = (a.coefficient && item.item_type && a.coefficient[item.item_type]) ? a.coefficient[item.item_type] : 1;
              if (item.response_evaluation !== 'SO' && item.response_evaluation !== 'PO') {
                let maxItem = 0;
                for (const key in item.evaluation) { if (item.evaluation[key] > maxItem) { maxItem = item.evaluation[key]; } }
                tm += coeff * maxItem;
                if (item.response_evaluation === 'NC') {
                  const ncKey = ['NCMIN', 'NCMOD', 'NCMAJ', 'NCCRI'].find(k => item.evaluation[k] !== undefined);
                  if (ncKey) { tv += coeff * item.evaluation[ncKey]; }
                } else if (item.response_evaluation) {
                  tv += coeff * (item.evaluation[item.response_evaluation] || 0);
                }
                const evalKey = item.response_evaluation === 'NC' ? 'NCMIN' : item.response_evaluation;
                malusP += m[evalKey] || 0;
              }
              if (item.response_evaluation === 'NCCRI') { nbKO++; }
            });
          });
          const nMax = a.noteMax || 100;
          const raw = tm > 0 ? Math.round((tv / tm) * nMax * 10) / 10 : 0;
          let note = raw * (1 - malusP / 100);
          const ko = a.ko || {};
          const avKo = koOrder.filter(k => ko[k] !== undefined && ko[k] !== null);
          if (nbKO > 0 && avKo.length > 0) {
            const malusKO = ko[avKo[Math.min(nbKO, avKo.length) - 1]] || 0;
            note = malusKO >= 100 ? 0 : Math.round(note * (1 - malusKO / 100) * 10) / 10;
          }
          return Math.min(Math.max(note, 0), nMax);
        };

        audit.global_note = calcGlobalNote(audit);

        old.forEach((oldAudit: any, i: number) => {
          oldAudit.items = [];
          (oldAudit.audit_item_groups || []).forEach((group: any) => {
            (group.audit_items || []).forEach((item: any) => {
              oldAudit.items.push(item);
              if (Array.isArray(item.categories) && item.response_evaluation !== 'SO' && item.response_evaluation !== 'PO') {
                item.categories.forEach((cat: any) => addCategoryToStats(cat, item, i + 1));
              }
            });
          });
          oldAudit.global_note = calcGlobalNote(oldAudit);
        });

        const dialogConfig = { height: '90vh', width: '90vw', maxWidth: '90vw', disableClose: true } as MatDialogConfig;
        if (audit.frame_name === 'AUDIT PHOTO') {
          this.dialog.open(PreviewAuditPictureDialogComponent, {
            ...dialogConfig,
            data: { audit, file_url: environment.SERVER_HOST + 'img/photos/' }
          } as MatDialogConfig);
        } else {
          this.dialog.open(PreviewAuditDialogComponent, {
            ...dialogConfig,
            data: { audit, stats, old, file_url: environment.SERVER_HOST + 'img/photos/', frame_evaluation_options: frameEvalOptions }
          } as MatDialogConfig);
        }
      } else {
        this.snackBar.open(this.i18n({ value: 'An error has occurred, please try again.', id: 'ErrorDatabase' }), '', { duration: 5000 } as MatSnackBarConfig);
      }
    }, () => {
      this.snackBar.open(this.i18n({ value: 'An error has occurred, please try again.', id: 'ErrorDatabase' }), '', { duration: 5000 } as MatSnackBarConfig);
    });
  }

  clone(row) {
    const rowsend = {name : row.Audits.frame_name, id : row.Audits.id};

    this.dialog.open(CopyDialogComponent, {
      data: rowsend,
    } as MatDialogConfig).afterClosed().subscribe((id) => {
      if (id) {
        this.http.get( environment.API_PATH + 'audit/clone/' + row.Audits.id, {withCredentials: true}).subscribe((response) => {
          if (response['success']) {
            this.snackBar.open(this.i18n({value: 'Your audit was clone in draft.', id: 'AuditCloneToast'}), '', {duration: 5000});
          } else {
            this.snackBar.open(this.i18n({value: 'An error has occurred, please try again.', id: 'ErrorDatabase'}), '', {duration: 5000});
          }
          this.changeDetectorRefs.detectChanges();
        }, err => {
          this.snackBar.open(this.i18n({value: 'An error has occurred, please try again.', id: 'ErrorDatabase'}), '', {duration: 5000});
          this.changeDetectorRefs.detectChanges();
        });
      }
    });
  }
}

export class DataHttpDao extends NewHttpDao {
  constructor(
    private authGuard: AuthGuard,
    private http: HttpClient,
    private internal: boolean,
    private state: string,
  ) {
    super();
  }

  getData(search: any, sort: string, order: string, limit: number, page: number) {
    const href = environment.API_PATH + 'audit';
    const requestUrl = `${href}?search=${search}&sort=${sort}&order=${order}&limit=${limit}&page=${page + 1}&type=${this.state}&self=${this.internal ? 'yes' : ''}&enterprise=` + this.authGuard.getCurrentEnterpriseId();
    return this.http.get(requestUrl, {withCredentials: true});
  }
}

export class AuditsDataSource extends DataGeneric {
  constructor(
    protected changeDetectorRefs: ChangeDetectorRef,
    protected getAuditsDatabase: DataHttpDao,
    protected columns: ListColumn[],
    protected sort: MatSort,
    protected paginator: MatPaginator,
  ) {
    super(changeDetectorRefs, getAuditsDatabase, columns, sort, paginator);
  }

  protected readDatabaseResult(result: any): any[] {
    return result.audits.map(issue => {
      let zero = '';
      for (let i = issue.id.toString().length; i < 10; i++) {
        zero += '0';
      }
      return {
        Audits: {
          id: zero + issue.id,
          started_at: issue.started_at,
          frame_name: issue.frame_name,
          statut: issue.statut,
          status_analyse_produit: issue.status_analyse_produit,
          status_analyse_surface: issue.status_analyse_surface,
          auditor_id: issue.auditor_id,
          variation_analyse : issue.variation_analyse,
          is_draft : issue.is_draft,
          // tslint:disable-next-line:triple-equals
          note: (issue.frame_name != 'AUDIT PHOTO') ? issue.global_note.toFixed(1) + ' /'+ issue.noteMax : '',
        },
        Auditor: {
          name: issue.auditor.name
        },
        Audited: {
          name: issue.audited.name
        },
        CreatedBy: {
          name: ((issue.created_by)? (issue.created_by.firstname + ' ' + issue.created_by.lastname) : ''),
        },
        DoneBy: {
          name: ((issue.done_by)? (issue.done_by.firstname + ' ' + issue.done_by.lastname) : '')
        }
      };
    });
  }

}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/pages/audits/audit-list/audit-list.component.ts